import http from "../http-common";

class SoftwareTicketDataService {
    getAll(offsetValue, sortBy, sortOrder, user_id_asking) {    // get the next chunk of 10 tickets
        return http.get(`/softwareTickets?offset=${offsetValue}&sortBy=${sortBy}&sortOrder=${sortOrder}&userIdAsking=${user_id_asking}`, {
            withCredentials: true
        });
    }

    // User clicked a new category in filter menu, but had no search text dialog
    filterByCategory(categoryID, offsetValue, sortBy, sortOrder, user_id_asking) {
        return http.get(`/softwareTickets?categoryID=${categoryID}&offset=${offsetValue}&sortBy=${sortBy}&sortOrder=${sortOrder}&userIdAsking=${user_id_asking}`, {
            withCredentials: true
        });
    }

    // User clicked a new category with search text or entered search text while on category != All Categories
    filterByCategoryAndSearchText(categoryName, offsetValue, searchText, sortBy, sortOrder, user_id_asking) {
        return http.get(`/softwareTickets?categoryName=${categoryName}&searchText=${searchText}&offset=${offsetValue}&sortBy=${sortBy}&sortOrder=${sortOrder}&userIdAsking=${user_id_asking}`, {
            withCredentials: true
        });
    }

    // Add a new software ticket to the database
    createSoftwareTicket(data) {
        return http.post("/softwareTickets", data, {
            withCredentials: true
        });
    }

    // Get specific ticket (also increments view count)
    get(id) {
        return http.get(`/softwareTickets/${id}`, {
            withCredentials: true
        });
    }

    // Get all comments associated with a ticket
    getComments(id) {
        return http.get(`/softwareTickets/${id}/comments`, {
            withCredentials: true
        });
    }

    // get like or dislike or none based on ticket
    getLikesDislikes(id, uid){
        return http.get(`/softwareTickets/${id}/likesdislikes?uid=${uid}`, {
            withCredentials: true
        });
    }

    // get Software ticket email status based on ticket and user 
    getBoolIndividualSoftwareTicketEmails(id, uid, globalSoftwareEmailStatus) {
        return http.get(`/softwareTickets/${id}/getIndividualSoftwareEmailStatus?uid=${uid}&globalSoftwareEmailStatus=${globalSoftwareEmailStatus}`, {
            withCredentials: true
        });
    }

    // changes  disabling or enabling of emails based on user id and software ticket
    changeIndividualSoftwareTicketEmailStatus(id, uid, data) {
        return http.put(`/softwareTickets/${id}/updateIndividualSoftwareTicketEmailStatus?uid=${uid}`, data, {
            withCredentials: true
        });
    }

    // add a like to ticket
    addLike(id, uid) {
        return http.get(`/softwareTickets/${id}/like?uid=${uid}`, {
            withCredentials: true
        });
    }

    // add a dislike to ticket
    addDislike(id, uid) {
        return http.get(`/softwareTickets/${id}/dislike?uid=${uid}`, {
            withCredentials: true
        });
    }

    createSoftwareTicketComment(data) {
        return http.post("/softwareTickets/comments", data, {
            withCredentials: true
        });
    }

    addSolution(id, data) {

        return http.put(`/softwareTickets/${id}/addSolution`, data, {
            withCredentials: true
        });
    }

    // Data not used here, but expected by put operation. All values updating are hardcoded to null
    removeSolution(id, data) {
        return http.put(`/softwareTickets/${id}/removeSolution`, data, {
            withCredentials: true
        });
    }

    // Get data to populate the create new software ticket form
    // (user's assigned software assets, ticket categories, name/id of site)
    getNewTicketFormData(id) {
        return http.get(`/softwareTickets/${id}/newTicketFormData`, {
            withCredentials: true
        });
    }

    editSoftwareTicket(id, data) {
        return http.put(`/softwareTickets/${id}/editSoftwareTicket`, data, {
            withCredentials: true
        });
    }

    // // update(id, data) {
    // //     return http.put(`/accounts/${id}`, data, {headers: {Authorization: 'Bearer ' + token}});
    // // }

    // // delete(id) {
    // //     return http.delete(`/accounts/${id}`, {headers: {Authorization: 'Bearer ' + token}});
    // // }

    // User typed in search criteria but had All Categories selected

    findByText(searchText, offsetValue, sortBy, sortOrder, user_id_asking) {
        return http.get(`/softwareTickets?searchText=${searchText}&offset=${offsetValue}&sortBy=${sortBy}&sortOrder=${sortOrder}&userIdAsking=${user_id_asking}`, {
            withCredentials: true
        });
    }

    // User typed in content into the ticket title form input. Note: "all" was required in the the endpoint to distinguish from /softwareTickets/:id on backend
    findRelatedTickets(titleText, user_id_asking) {
        return http.get(`/softwareTickets/all/relatedTickets?titleText=${titleText}&userIdAsking=${user_id_asking}`, {
            withCredentials: true
        });
    }

    // sends designated ticket id and new assigned tech id to update the backend record of that ticket
    updateTechAssignment(id, data) {
        return http.put(`/softwareTickets/${id}/updateTechAssignment`, data, {
            withCredentials: true
        });
    }
}


export default new SoftwareTicketDataService();